// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
//para poderla exportar
import { getFirestore } from "firebase/firestore";
//Autenticacion
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "terra-castilla.firebaseapp.com",
  projectId: "terra-castilla",
  storageBucket: "terra-castilla.appspot.com",
  messagingSenderId: "838448211765",
  appId: "1:838448211765:web:f421331f0ef7f62605ce7c",
  measurementId: "G-JSV1BXXD4K",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
//autenticacion
export const auth = getAuth(app);
export const db = getFirestore(app);
